import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { updateProgramme } from '@api';
import { currentProgrammeUpdated } from '@store/programme';

export const markWelcomeAsCompleted = (): ThunkAction<
    void,
    any,
    any,
    Action<any>
> => {
    return async (dispatch) => {
        const updatedProgrammeFields = {
            onboarding_completed: true,
        };
        const updatedProgramme = await updateProgramme(updatedProgrammeFields);
        dispatch(currentProgrammeUpdated(updatedProgramme));
    };
};
